import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PendenciasComponent } from './pendencias.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { PendenciasService } from './pendencias.service';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        PoModule,
        PoPageDynamicTableModule,
        PoPageDynamicEditModule,
        SharedModule
  ],
  declarations: [PendenciasComponent],
  providers: [PendenciasService]
})
export class PendenciasModule { }



